import { render, staticRenderFns } from "./station.vue?vue&type=template&id=c1bb263e&scoped=true&"
import script from "./station.vue?vue&type=script&lang=js&"
export * from "./station.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bb263e",
  null
  
)

export default component.exports